const dragDirective = {
    bind(el) {
        let isDown = false;
        let startX;
        let scrollLeft;

        const handleMouseDown = (e) => {
            isDown = true;
            startX = e.pageX - el.offsetLeft;
            scrollLeft = el.scrollLeft;
            el.style.cursor = 'grabbing'; // 更改光标样式
        };

        const handleMouseLeave = () => {
            isDown = false;
            el.style.cursor = 'grab'; // 恢复光标样式
        };

        const handleMouseUp = () => {
            isDown = false;
            el.style.cursor = 'grab'; // 恢复光标样式
        };

        const handleMouseMove = (e) => {
            if (!isDown) return; // 如果没有按下鼠标，则不执行
            const x = e.pageX - el.offsetLeft;
            const walk = (x - startX) * 2; // 滚动速度
            el.scrollLeft = scrollLeft - walk;
        };

        el.addEventListener('mousedown', handleMouseDown);
        el.addEventListener('mouseleave', handleMouseLeave);
        el.addEventListener('mouseup', handleMouseUp);
        el.addEventListener('mousemove', handleMouseMove);
    },
};

export default dragDirective;
